// Verdict types used throughout the application
export const VERDICTS = {
  GREAT_INSIGHT: 'Great Insight',
  GOOD_INSIGHT: 'Good Insight',
  NEEDS_IMPROVEMENT: 'Needs Improvement'
};

// Verdict display with exclamation mark
export const VERDICT_DISPLAY = {
  [VERDICTS.GREAT_INSIGHT]: 'Great Insight!',
  [VERDICTS.GOOD_INSIGHT]: 'Good Insight',
  [VERDICTS.NEEDS_IMPROVEMENT]: 'Needs Improvement'
};

// CSS classes for different verdict types
export const VERDICT_CLASSES = {
  [VERDICTS.GREAT_INSIGHT]: {
    border: 'border-yellow-400/70',
    badge: 'bg-amber-500/20 text-amber-300 border border-amber-400/40 shadow-inner shadow-amber-400/10 animate-shimmer'
  },
  [VERDICTS.GOOD_INSIGHT]: {
    border: 'border-green-500/30',
    badge: 'bg-green-500/20 text-green-300 border border-green-500/30'
  },
  [VERDICTS.NEEDS_IMPROVEMENT]: {
    border: 'border-red-500/30',
    badge: 'bg-red-500/20 text-red-300 border border-red-500/30'
  }
};